/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_LeadInputs */

const en_mcphosted_hub_lead = /** @type {(inputs: Mcphosted_Hub_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep exposes an MCP server over HTTP. Add it as a custom connector and drive the Runner from Claude.ai, ChatGPT or Cursor — the chat asks, Bystep builds, you get a link to try.`)
};

const id_mcphosted_hub_lead = /** @type {(inputs: Mcphosted_Hub_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep menyediakan server MCP lewat HTTP. Pasang sebagai konektor kustom, lalu jalankan Runner dari Claude.ai, ChatGPT, atau Cursor — chat yang meminta, Bystep yang membangun, kamu terima tautannya.`)
};

/**
* | output |
* | --- |
* | "Bystep exposes an MCP server over HTTP. Add it as a custom connector and drive the Runner from Claude.ai, ChatGPT or Cursor — the chat asks, Bystep builds, y..." |
*
* @param {Mcphosted_Hub_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_lead = /** @type {((inputs?: Mcphosted_Hub_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_lead(inputs)
	return en_mcphosted_hub_lead(inputs)
});